<template>
  <div>
    <v-stepper v-model="e6" vertical>
      <v-stepper-step :complete="e6 > 1" step="1">
        Datos personales
        <small>Escribe los datos del miembro</small>
      </v-stepper-step>

      <v-stepper-content step="1">
        <v-form ref="form" v-model="formDatosPersonales">
          <v-card class="mb-12">
            <v-text-field
              ref="nombre"
              label="Nombre completo"
              :rules="reglasForm"
              v-model="datosPersonales.nombre"
              @keydown.enter="$refs.telefono.focus()"
            >
            </v-text-field>
            <v-text-field
              ref="telefono"
              label="Teléfono"
              :rules="reglasForm"
              v-model="datosPersonales.telefono"
              @keydown.enter="$refs.direccion.focus()"
            >
            </v-text-field>
            <v-text-field
              ref="direccion"
              label="Dirección"
              :rules="reglasForm"
              v-model="datosPersonales.direccion"
              @keydown.enter="$refs.edad.focus()"
            >
            </v-text-field>
            <v-text-field
              ref="edad"
              label="Edad"
              :rules="reglasForm"
              v-model="datosPersonales.edad"
              @keydown.enter.prevent="$refs.continuarBtn1.$el.focus()"
            >
            </v-text-field>
          </v-card>
          <v-btn
            ref="continuarBtn1"
            color="primary"
            @click="e6 = 2"
            :disabled="!formDatosPersonales"
          >
            Continuar
          </v-btn>
          <v-btn text to="/miembros"> Cancelar </v-btn>
        </v-form>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 2" step="2">
        Datos de contacto
        <small
          >Escribe los siguientes datos en caso de que algun accidente
          ocurra</small
        >
      </v-stepper-step>

      <v-stepper-content step="2">
        <v-form ref="form" v-model="formDatosContacto">
          <v-card class="mb-12">
            <v-switch
              v-model="datosContacto.sufreEnfermedad"
              label="¿Sufre alguna enfermedad crónica?"
            ></v-switch>
            <v-text-field
              label="Escribe las enfermedades"
              v-if="datosContacto.sufreEnfermedad"
              v-model="datosContacto.enfermedad"
            ></v-text-field>
            <v-switch
              v-model="datosContacto.tieneSeguro"
              label="¿Tiene seguro?"
            ></v-switch>
            <v-text-field
              label="Escribe las institución de seguro"
              v-if="datosContacto.tieneSeguro"
              v-model="datosContacto.institucion"
            ></v-text-field>
            <v-text-field
              label="Nombre completo de contacto"
              :rules="reglasForm"
              v-model="datosContacto.nombreContacto"
              @keydown.enter="$refs.telefonoContacto.focus()"
            >
            </v-text-field>
            <v-text-field
            ref="telefonoContacto"
              label="Teléfono"
              :rules="reglasForm"
              v-model="datosContacto.telefonoContacto"
              @keydown.enter.prevent="$refs.continuarBtn2.$el.focus()"
            >
            </v-text-field>
          </v-card>
          <v-btn
            ref="continuarBtn2" 
            color="primary" @click="e6 = 3" :disabled="!formDatosContacto">
            Continuar
          </v-btn>
          <v-btn text @click="e6 = 1"> Regresar </v-btn>
        </v-form>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > 3" step="3">
        Datos físicos
        <small>Ingresa los datos físicos del miembro (opcional)</small>
      </v-stepper-step>

      <v-stepper-content step="3">
        <v-form ref="form" v-model="formDatosFisicos">
          <v-card class="mb-12">
            <v-text-field
              label="Peso (kg)"
              type="number"
              step="0.01"
              v-model="datosFisicos.peso"
              @keydown.enter="$refs.objetivo.focus()"
            ></v-text-field>
            <v-text-field
              ref="objetivo"
              label="Objetivo"
              v-model="datosFisicos.objetivo"
              @keydown.enter="$refs.altura.focus()"
            ></v-text-field>
            <v-text-field
              ref="altura"
              label="Altura (m)"
              type="number"
              step="0.01"
              v-model="datosFisicos.altura"
              @keydown.enter="$refs.medidaPecho.focus()"
            ></v-text-field>
            <h4>Medidas (cm)</h4>
            <v-text-field
              ref="medidaPecho"
              label="Pecho"
              type="number"
              step="0.01"
              v-model="datosFisicos.medidaPecho"
              @keydown.enter="$refs.medidaCintura.focus()"
            ></v-text-field>
            <v-text-field
              ref="medidaCintura"
              label="Cintura"
              type="number"
              step="0.01"
              v-model="datosFisicos.medidaCintura"
              @keydown.enter="$refs.medidaTriceps.focus()"
            ></v-text-field>
            <v-text-field
              ref="medidaTriceps"
              label="Triceps"
              type="number"
              step="0.01"
              v-model="datosFisicos.medidaTriceps"
              @keydown.enter="$refs.medidaBiceps.focus()"
            ></v-text-field>
            <v-text-field
              ref="medidaBiceps"
              label="Biceps"
              type="number"
              step="0.01"
              v-model="datosFisicos.medidaBiceps"
              @keydown.enter="$refs.medidaGluteos.focus()"
            ></v-text-field>
            <v-text-field
              ref="medidaGluteos"
              label="Glúteos"
              type="number"
              step="0.01"
              v-model="datosFisicos.medidaGluteos"
              @keydown.enter="$refs.medidaCuadriceps.focus()"
            ></v-text-field>
             <v-text-field
              ref="medidaCuadriceps"
              label="Cuádriceps"
              type="number"
              step="0.01"
              v-model="datosFisicos.medidaCuadriceps"
              @keydown.enter="$refs.medidaPantorrilla.focus()"
            ></v-text-field>
            <v-text-field
              ref="medidaPantorrilla"
              label="Pantorrilla"
              type="number"
              step="0.01"
              v-model="datosFisicos.medidaPantorrilla"
              @keydown.enter="$refs.espalda.focus()"
            ></v-text-field>
             <v-text-field
              ref="espalda"
              label="Espalda"
              type="number"
              step="0.01"
              v-model="datosFisicos.medidaEspalda"
              @keydown.enter="$refs.fechaMedidasInput.focus()"
            ></v-text-field>
             <v-menu
                v-model="menuFechaMedidas"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    ref="fechaMedidasInput"
                    v-model="datosFisicos.fechaMedidas"
                    label="Fecha de las medidas"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @focus="menuFechaMedidas = true"
                    @keydown.enter="datosFisicos.fechaMedidas ? $refs.continuarBtn3.$el.focus() : null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="datosFisicos.fechaMedidas"
                  @input="menuFechaMedidas = false"
                  locale="es"
                ></v-date-picker>
              </v-menu>
          </v-card>
          <v-btn ref="continuarBtn3" color="primary" @click="e6 = 4">
            Continuar
          </v-btn>
          <v-btn text @click="e6 = 2"> Regresar </v-btn>
        </v-form>
      </v-stepper-content>

      <v-stepper-step step="4">
        Foto
        <small>Escoge alguna foto del miembro</small>
      </v-stepper-step>

      <v-stepper-content step="4">
        <v-card class="mb-12">
          <v-file-input
            ref="fotoInput"
            :rules="reglaImagen"
            accept="image/png, image/jpeg, image/bmp"
            placeholder="Selecciona una imagen"
            prepend-icon="mdi-camera"
            label="Foto"
            v-model="imagen"
            type="file"
            @change="onSeleccionarImagen"
            @keydown.enter="$refs.registrarBtn.$el.focus()"
          ></v-file-input>
          <div class="d-flex flex-column justify-space-between align-center">
            <img :src="imagenUrl" alt="" aspect-ratio="16/9" width="300" />
          </div>
          <v-card-actions class="justify-center">
            <v-btn ref="registrarBtn" color="primary" x-large @click="registrar"> Registrar </v-btn>
            <v-btn text x-large @click="e6 = 3"> Regresar </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>
<script>
import Utiles from '../../Servicios/Utiles'
export default {
  name: "FormMiembro",
  props: ["miembro"],

  data: () => ({
    formDatosPersonales: false,
    formDatosContacto: false,
    formDatosFisicos: false,
    reglasForm: [(value) => !!value || "Debes colocar este campo."],
    reglaImagen: [
      (value) =>
        !value || value.size < 5000000 || "La foto debe pesar menos de 5 MB!",
    ],
    e6: 1,
    imagen: null,
    imagenUrl: null,
    datosPersonales:{
       nombre: "",
        telefono: "",
        direccion: "",
        edad: 0,
    },
    datosContacto: {
      sufreEnfermedad: false,
        tieneSeguro: false,
        enfermedad: "",
        institucion: "",
        nombreContacto: "",
        telefonoContacto: ""
    },
    datosFisicos: {
      peso: null,
      objetivo: "",
      altura: null,
      medidaPecho: null,
      medidaCintura: null,
      medidaTriceps: null,
      medidaBiceps: null,
      medidaGluteos: null,
      medidaCuadriceps: null,
      medidaPantorrilla: null,
      medidaEspalda: null,
      fechaMedidas: null,
    },
    menuFechaMedidas: false,
  }),

  mounted() {
    //console.log(this.miembro)
    //this.datosPersonales = this.miembro.datosPersonales
    //this.datosContacto = this.miembro.datosContacto
    //this.imagenUrl = this.miembro.imagen
    this.formDatosPersonales = false;
    this.formDatosContacto = false;
    this.formDatosFisicos = false;

  },

  methods: {

    registrar() {
      let miembro = {
        ...this.datosPersonales,
        ...this.datosContacto,
        ...this.datosFisicos,
        imagen: this.imagenUrl,
      };

      this.$emit("registrado", miembro)

      console.log(miembro)

      this.formDatosPersonales =  false
      this.formDatosContacto = false
      this.formDatosFisicos = false
      this.e6= 1
      this.imagen= null
      this.imagenUrl= null
      this.datosPersonales= {
        nombre: "",
        telefono: "",
        direccion: "",
        edad: 0,
      }
      this.datosContacto = {
        sufreEnfermedad: false,
        tieneSeguro: false,
        enfermedad: "",
        institucion: "",
        nombreContacto: "",
        telefonoContacto: "",
      }
      this.datosFisicos = {
        peso: null,
        objetivo: "",
        altura: null,
        medidaPecho: null,
        medidaCintura: null,
        medidaTriceps: null,
        medidaBiceps: null,
        medidaGluteos: null,
        medidaCuadriceps: null,
        medidaPantorrilla: null,
        medidaEspalda: null,
        fechaMedidas: null,
      }
    },

    crearImagen(imagen){
      const reader = new FileReader()

      reader.onload = e => {
        this.imagenUrl = e.target.result
      }
      reader.readAsDataURL(imagen)
    },

    onSeleccionarImagen() {
      if (!this.imagen) {
        return
      }
      this.crearImagen(this.imagen);
    }
  },

  watch: {
    miembro:{ 
      deep: true,
      handler() {
        this.datosPersonales = this.miembro.datosPersonales
        this.datosContacto = this.miembro.datosContacto
        this.imagenUrl = Utiles.generarURL(this.miembro.imagen)
        
       }
    }
  }

};
</script>


// WEBPACK FOOTER //
// src/components/Miembros/FormMiembro.vue